import React, { useState, useEffect } from "react";
import { GetList } from "../../../hook/getList.tsx";
import moment from "moment";
import { Dropdown } from "../../../component/Dropdow/index.tsx";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import Pagination from "../../../component/Pagination/index.tsx";
import { useDispatch, useSelector } from "react-redux";
import {
  historySelect,
  setDataRequestCp,
} from "../../../store/slice/historyRequestCoupon.slice.tsx";

interface PageChangeEvent {
  selected: number;
}

function HistoryStaffRequest() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const storedBranch = localStorage.getItem("branch");
  const storedStartDate = localStorage.getItem("startDate");
  const storedEndDate = localStorage.getItem("endDate");
  const localPage = localStorage.getItem("page");
  const dispatch = useDispatch();
  const [branch, setbranch] = useState<string>(
    searchParams.get("branch") || storedBranch || "",
  );
  const [curentPage, setCurentPage] = useState(
    parseInt(searchParams.get("page") || localPage || "1"),
  );
  const { dataRequestCp } = useSelector(historySelect);
  const [startDate, setStartDate] = useState<any>(
    searchParams.get("startDate")
      ? new Date(searchParams.get("startDate")!)
      : storedStartDate
        ? new Date(storedStartDate)
        : new Date(),
  );
  const [endDate, setEndDate] = useState<any>(
    searchParams.get("endDate")
      ? new Date(searchParams.get("endDate")!)
      : storedEndDate
        ? new Date(storedEndDate)
        : new Date(),
  );
  // const [dataBranch, setDataBranch] = useState<Array<{title: string}>>([]);

  const [dataBranch, setDataBranch] = useState<
    Array<{ title: string; code: string }>
  >([]);

  const { data: branchRes }: any = GetList({
    url: "users/getListUser",
    params: { limit: 1000, page: 1, role: "STAFF", search: "" },
  });

  useEffect(() => {
    const raw = branchRes?.data?.results ?? branchRes?.results ?? [];
    const results: Array<{
      name: string;
      email?: string;
      branh_resgisted: string;
      role?: string;
    }> = Array.isArray(raw) ? raw : [];

    const mapped = results
      .filter((b) => b?.branh_resgisted && (!b.role || b.role === "STAFF"))
      .filter(
        (b, index, arr) =>
          arr.findIndex((x) => x.branh_resgisted === b.branh_resgisted) ===
          index,
      )
      .map((b) => {
        const name = b.name || b.branh_resgisted;
        return {
          title: b.email ? `${name} - ${b.email}` : name,
          code: b.branh_resgisted,
        };
      });

    setDataBranch([{ title: "ALL", code: "ALL" }, ...mapped]);
  }, [branchRes]);

  useEffect(() => {
    if (startDate) {
      localStorage.setItem("startDate", startDate.toString());
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("startDate", startDate.toISOString());
      setSearchParams(newSearchParams);
    }
  }, [startDate, searchParams, setSearchParams]);

  useEffect(() => {
    if (curentPage) {
      localStorage.setItem("page", curentPage?.toString());
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("page", curentPage.toString());
      setSearchParams(newSearchParams);
    }
  }, [curentPage, searchParams, setSearchParams]);

  useEffect(() => {
    if (endDate) {
      localStorage.setItem("endDate", endDate.toString());
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("endDate", endDate.toISOString());
      setSearchParams(newSearchParams);
    }
  }, [endDate, searchParams, setSearchParams]);

  const {
    data: dataHistory,
    loadMore,
    loading,
  } = GetList<any>({
    url: "staff/admin-get-history-request",
    isLazy: true,
    params: {
      limit: 10,
      createdAt_gte: moment(startDate).format("YYYY-MM-DD"),
      createdAt_lte: moment(endDate).format("YYYY-MM-DD"),
      ...(branch && branch !== "ALL" ? { branch_is: branch } : {}),
    },
  });
  const list = dataHistory?.results || [];
  const totalPages = dataHistory?.totalPages || 0;

  // console.log("Current page:", curentPage, "Total pages:", totalPages);

  useEffect(() => {
    if (dataHistory?.results?.length > 0) {
      dispatch(setDataRequestCp(dataHistory.results));
    }
    if (dataHistory?.results?.length === 0 && !loading) {
      dispatch(setDataRequestCp([]));
    }
  }, [dataHistory]);

  useEffect(() => {
    setCurentPage(1);
    loadMore(1);
  }, []);

  useEffect(() => {
    setCurentPage(1);
    loadMore(1);
  }, [branch, startDate, endDate]);

  const handlePageChange = ({ selected }: PageChangeEvent) => {
    const newPage = selected + 1;
    console.log(
      "Page change - Selected:",
      selected,
      "New page:",
      newPage,
      "Total pages:",
      totalPages,
    );
    if (newPage >= 1 && newPage <= totalPages) {
      setCurentPage(newPage);
      loadMore(newPage);
    }
  };

  type TypeHistory = {
    _id: string;
    name: string;
    userId: string;
    url: string;
    description: string;
    branch: string;
    date: string;
    coupon: {
      EVENT_HDD: string;
      Description_E: string | null;
      Description_K: string;
      Description_V: string;
      SEQ: number;
      EVENT_POINT: string;
      USE_YN: string;
      USE_HDD: string;
      CREATE_DATE: string;
      UPDATE_DATE: string | null;
      PRICE: string;
      User_id: string;
      Send_date: string;
      Titile: string;
      Category: string;
      Titile_K: string | null;
      Titile_E: string | null;
    };
    createdAt: string;
    updatedAt: string;
    __v: number;
  };

  const renderHistory = (item: TypeHistory, index: number) => {
    return (
      <tr
        key={index}
        onClick={() =>
          navigate("/admin/detail-request-couon", {
            state: { item, startDate, endDate, branch },
          })
        }
        className="hover:bg-pink-50 transition-colors duration-200 cursor-pointer border-b border-gray-100"
      >
        <td className="px-4 py-4 text-gray-600 font-medium">
          {(curentPage - 1) * 10 + index + 1}
        </td>
        <td className="px-4 py-4 text-gray-700">
          {moment(item.date).format("DD/MM/YYYY")}
        </td>
        <td className="px-4 py-4">
          <span className="bg-pink-100 text-[#AD287D] px-3 py-1 rounded-full text-sm font-medium">
            {item.coupon.EVENT_POINT}
          </span>
        </td>
        <td className="px-4 py-4 text-gray-700 font-medium">
          {item.coupon.Titile || item.coupon.Category}
        </td>
        <td className="px-4 py-4 text-green-600 font-semibold">
          {item.coupon.PRICE?.toLocaleString()}đ
        </td>
        <td className="px-4 py-4">
          <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
            {item.branch}
          </span>
        </td>
        <td className="px-4 py-4 text-gray-700">{item.name}</td>
        <td className="px-4 py-4">
          <span
            className={`px-3 py-1 rounded-full text-sm font-medium ${
              item.coupon.USE_YN === "N"
                ? "bg-yellow-100 text-yellow-700"
                : "bg-green-100 text-green-700"
            }`}
          >
            {item.coupon.USE_YN === "N" ? "Chưa sử dụng" : "Đã sử dụng"}
          </span>
        </td>
      </tr>
    );
  };

  return (
    <div>
      <h1 className="mt-10 text-5xl font-semibold text-center text-primary">
        Lịch sử
      </h1>

      <div className="flex flex-col items-center justify-center mt-10 text-center">
        <div className="w-[300px]">
          {/* <Dropdown
            data={dataBranch}
            placeholder="Chi nhánh"
            onSelectItem={(i) => {
              setbranch(i.title);
              dispatch(setDataRequestCp([]));
            }}
            filedKey="title"
            value={branch}
          /> */}

          <Dropdown
            data={dataBranch}
            placeholder="Chi nhánh"
            onSelectItem={(i) => {
              setbranch(i.code);
              dispatch(setDataRequestCp([]));
            }}
            filedKey="title"
            value={dataBranch.find((b) => b.code === branch)?.title || "ALL"}
          />
        </div>

        <div className="flex gap-5 my-3 ">
          <div>
            <h5 className="text-[pink]">Ngày bắt đầu</h5>
            <DateTimePicker
              format={"dd-MM-y"}
              disableClock={true}
              onChange={(date) => {
                setStartDate(date);
                dispatch(setDataRequestCp([]));
              }}
              value={startDate}
            />
          </div>

          <div>
            <h5 className="text-[pink]">Ngày kết thúc</h5>
            <DateTimePicker
              format={"dd-MM-y"}
              disableClock={true}
              onChange={(date) => {
                setEndDate(date);
                dispatch(setDataRequestCp([]));
              }}
              value={endDate}
            />
          </div>
        </div>
      </div>
      <div className="mt-6 max-w-8xl mx-auto w-full px-4">
        {loading ? (
          <div className="w-full h-full flex justify-center items-center mt-24">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[pink] mx-auto mb-4"></div>
              <div className="text-[pink] font-medium">Đang tải dữ liệu...</div>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-3xl shadow-lg border-2 border-[pink]/20 overflow-hidden">
            {list?.length > 0 ? (
              <>
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-[pink]">
                      <tr>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">
                          #
                        </th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">
                          Ngày Tạo
                        </th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">
                          Mã Coupon
                        </th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">
                          Tên Coupon
                        </th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">
                          Giá Tiền
                        </th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">
                          Chi Nhánh
                        </th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">
                          Người Yêu Cầu
                        </th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">
                          Trạng Thái
                        </th>
                      </tr>
                    </thead>
                    <tbody>{list.map(renderHistory)}</tbody>
                  </table>
                </div>

                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                  <Pagination
                    pageCount={totalPages}
                    onPageChange={handlePageChange}
                    currentPage={curentPage}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={2}
                  />
                </div>
              </>
            ) : (
              <div className="text-center text-gray-500 py-16">
                <div className="text-4xl mb-4">📋</div>
                <div className="text-lg font-medium">Không có dữ liệu</div>
                <div className="text-sm">Vui lòng thử lại sau</div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default HistoryStaffRequest;
